/*!
 * room.js — the engine's way out to the other clients in the room
 * © 2026 Rob Canning — GPLv3
 *
 * The cues and the console send to the room through here, never through
 * the score's server connection (socket.js) itself: that keeps the engine
 * loadable on a page with no server (Oscilla Live, live.js). The score puts
 * its WebSocket on window.socket; with none open, a message goes nowhere.
 *
 * What comes back arrives as window events (roomEvents.js), made from the
 * messages by whatever carries the room: socket.js for the score's server,
 * roomLink.js for a relay (Oscilla Live). Anything else that joins the
 * console to a room -- a shared document two performers write in together
 * -- keeps to the same two ends: messages out here, events in.
 */

/** A message to the server and the room: { type, ...payload }. */
export function sendSocketMessage(type, payload = {}) {
  if (window.socket?.readyState === WebSocket.OPEN) {
    window.socket.send(JSON.stringify({ type, ...payload }));
  }
}

// The clients a targeted cue goes to (picked in the client list, clients.js).
// None picked: it goes to every client.
const selected = new Set();

export const isClientSelected = name => selected.has(name);

/** Pick a client, or let it go: true when it is picked now. */
export function toggleClientSelected(name) {
  if (selected.has(name)) selected.delete(name);
  else selected.add(name);
  return selected.has(name);
}

/** The picked clients' names, [] when none (= every client). */
export const getSelectedClients = () => [...selected];
